/**
 * 索赔详情 2.0
 *
 * Author:   FJJ
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/8/31      1.0     First version
 *
 * Copyright 2021-2023, all rights reserved. Essa.cn
 * */
import React from "react";
import {Spin,message} from 'antd';
import Lang from "@components/Lang/Lang"
import {symbolMoneyUtil,toFixed2,isEmpty,isEmptyObject} from '@utils/utils';
import AfterSaleInitiated from "./initiated";
import AfterSaleInitiatedByCustomer from "./initiatedByCustomer";
import qs from "query-string";
import AfterSaleService from "../AfterSale.action";
import "./detail.less";

export default class PoAfterSalesDetail extends React.Component{
    constructor(props) {
        super(props);
        this.__getServerLanguage = __getServerLanguage;
        //获取头部数据
        this.state = {
            claimDemageOrderId: (qs.parse(props.location.search) || {}).id,
            loading: false, //数据加载等待
            model:{},
        }
    }
    loading(flag){
        this.setState({
            loading:flag
        })
    }
    init(){
        if(this.state.claimDemageOrderId){
            const data ={
                claimDemageOrderId:this.state.claimDemageOrderId,
            }
            const sUrl =  "/service/mg/sale/claimDemage/claim-demage-info";
            this.loading(true)
            AfterSaleService.postHttpAction(sUrl,data,).then((resp)=>this.handleRes(resp.data)).catch(err=>this.handleRes(err));
        }
    }
    handleRes(resData={},poItemId=""){
        // 响应结果
        this.loading(false)
        let { success,valid,model={}} = resData;
        if(success&valid){
            if(model.damageCode){
                const list = __getDictList("claim_demage_order_damage_code");
                const curDamage = list.find(item=>item.code==model.damageCode)||{};
                model.damageCodeName =curDamage.name;
            }
            const mgPoInfoVO = model.mgPoInfoVO || {};
            let {values} = this.state;
             values = {...values,
                 quantity:model.cdQuantity,
                 refundAmount: mgPoInfoVO.pcsPrice,
                 refundAmountTotal: toFixed2(model.cdQuantity*mgPoInfoVO.pcsPrice),
            }
            this.setState({
                model:model,
                values:values
            },()=>{
                if(this.onRefPageMgChild)this.onRefPageMgChild.init();//工作台是读取state数据，所以重新初始化
            })

        }
    }
    /*
  * 撤消操作
  * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#7948
  * */
    handleCancel(){
        if(this.state.claimDemageOrderId){
            const data ={
                claimDemageOrderId:this.state.claimDemageOrderId,
            }
            const sUrl =  "/service/mg/sale/claimDemage/close";
            this.loading(true)
            AfterSaleService.postHttpAction(sUrl,data,).then((resp)=>this.handleSaveRes(resp.data)).catch(err=>this.handleSaveRes(err));
        }
    }
    handleSaveRes(resData={},){
        // 响应结果
        this.loading(false)
        const { success,valid,model={}} = resData;
        if(success&valid){
            message.success(Lang({id:"CaoZuoChengGong",default:"操作成功"}));
            // 刷新页面
            this.init();
        }else if(resData.message){
            message.error(resData.message);
        }else message.error(Lang({id:"CaoZuoShiBai",default:"操作失败"}));
    }
    onRefPageMg = (ref) => this.onRefPageMgChild = ref;
    componentWillMount() {
        this.init();
    }
    componentDidMount(){

    }
    render(){
        const { model,loading,claimDemageOrderId,values } = this.state;
        const mgPoInfoVO = model.mgPoInfoVO ||{};
        // 单位
        const businessPlatform = model.businessPlatform;
        return (<Spin spinning={loading}>
                <>
                {/*  兼容原链接，从统一的入口 进，查询到数据再转到对应显示组件，分平台及类型 审核及查看详情 */}
                {businessPlatform=="essaone"&&<AfterSaleInitiatedByCustomer model={model} claimDemageOrderId={claimDemageOrderId}
                                                                            handleCancel={()=>this.handleCancel()}
                                                                            successBack={()=>this.init()}/>}
                {businessPlatform=="mg"&&<AfterSaleInitiated onRef={this.onRefPageMg} add={false} model={model} claimDemageOrderId={claimDemageOrderId}
                                                             handleCancel={()=>this.handleCancel()}
                                                             successBack={()=>this.init()} />}
                </>
        </Spin>)
    }
}
